import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import { StepMap, steps } from '../../constants';

export const urgencyStepGraph: Beacon<StepMap> = {
	[steps.Urgency]: [steps.Address],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	// What ever logic is needed to determine the next step
	return steps.Address as StepMap;
};
